/**
 * LiveKit Utilities
 *
 * Token fetching and server URL configuration for LiveKit WebRTC streaming.
 */

import { resolveApiBaseUrl } from '@polygraf/shared'

const API_URL = resolveApiBaseUrl(import.meta.env.VITE_API_URL, 'http://localhost:4000')

if (API_URL === 'http://localhost:4000' && import.meta.env.PROD) {
	console.error(
		'[LiveKit] VITE_API_URL is not configured — falling back to localhost which will fail in production',
	)
}

export const LIVEKIT_URL = import.meta.env.VITE_LIVEKIT_URL ?? 'ws://localhost:7880'

export interface LivekitTokenResponse {
	serverUrl: string
	token: string
	identity: string
}

export async function fetchLivekitToken(
	roomName: string,
	role: 'broadcaster' | 'viewer',
	participantName?: string,
): Promise<LivekitTokenResponse> {
	const response = await fetch(`${API_URL}/api/livekit/token`, {
		method: 'POST',
		headers: { 'Content-Type': 'application/json' },
		credentials: 'include',
		body: JSON.stringify({ roomName, role, participantName }),
	})

	if (!response.ok) {
		const error = await response.json().catch(() => ({ error: 'Request failed' }))
		throw new Error(error.error ?? `Token request failed: ${response.status}`)
	}

	return response.json()
}
